import type { SlotTone } from './ScheduleStep.types';

/** Date chips shown at once in the schedule strip (UI only). */
export const MAX_VISIBLE_DATES = 15;

/**
 * Backend `get-available-slots` caps each request at 15 calendar days.
 * Not the max campaign length — frontend must batch longer ranges.
 */
export const MAX_AVAILABILITY_QUERY_DAYS = 15;

export function getSlotTone(
  selected: boolean,
  availableReps: number,
  totalReps: number,
): SlotTone {
  if (selected) return 'selected';
  if (availableReps <= 0) return 'full';
  const percent =
    totalReps > 0 ? (availableReps / totalReps) * 100 : availableReps > 0 ? 100 : 0;
  if (percent >= 70) return 'available';
  if (percent >= 30) return 'limited';
  return 'almostFull';
}

/** Restrained card surfaces — availability via accent, not full-tint backgrounds. */
export const SLOT_CARD_CLASS: Record<SlotTone, string> = {
  selected:
    'border-[var(--dash-brand)] bg-[var(--dash-brand-soft)] shadow-[0_0_0_1px_var(--dash-brand)]',
  available:
    'border-[#E6E8EF] bg-white hover:border-[var(--dash-brand)]/40',
  limited:
    'border-[#E6E8EF] bg-white hover:border-amber-400/60',
  almostFull:
    'border-[#E6E8EF] bg-white hover:border-rose-400/50',
  full: 'border-[#E6E8EF] bg-[#F8F9FB] opacity-55',
};

export const SLOT_DOT_CLASS: Record<SlotTone, string> = {
  selected: 'bg-[var(--dash-brand)]',
  available: 'bg-emerald-500',
  limited: 'bg-amber-500',
  almostFull: 'bg-rose-500',
  full: 'bg-[#C4C9D4]',
};

export const SLOT_STATUS_LABEL: Record<SlotTone, string> = {
  selected: 'Selected',
  available: 'Available',
  limited: 'Limited',
  almostFull: 'Low',
  full: 'Full',
};

export const SLOT_STATUS_TEXT: Record<SlotTone, string> = {
  selected: 'text-[var(--dash-brand)]',
  available: 'text-[#6B7289]',
  limited: 'text-amber-700',
  almostFull: 'text-rose-700',
  full: 'text-[#9CA3AF]',
};

export const SLOT_BAR_CLASS: Record<SlotTone, string> = {
  selected: 'bg-[var(--dash-brand)]',
  available: 'bg-emerald-500',
  limited: 'bg-amber-500',
  almostFull: 'bg-rose-500',
  full: 'bg-[#C4C9D4]',
};
